import { v4 as uuidv4 } from 'uuid';
import QuizTypes from "types/QuizTypes";

export const initialQuizForm = {
  backgroundImage: 'https://media.quizwizards.com/bg-main-2.jpg',

  type: QuizTypes.Scoring,

  landingPage: {
    buttonTitle: 'Play now',
    title1: 'Who is your',
    title2: 'Player',
    title3: 'Of the year',
    image: 'https://media.quizwizards.com/default-logo.png',
    imageBackgroundColor: 'rgba(255, 255, 255, 0)',
    imageShadowEnabled: true,
    backgroundImage: 'https://media.quizwizards.com/bg-home-2.jpg',
  },
  registrationPage: {
    anonymous: false,
    caption: '',
    showPriorQuiz: false,
    requirePhoneNumber: false,
    showDateOfBirth: true,
    showAgreeAllCheckbox: true,
    useExistingPlayer: false,
    showRequiredHint: true,
  },
  brand: '',
  brandVideo: '',
  endsDate: '',
  logoImage: '',
  logoFormat: 'logo',
  logoImageBackgroundColor: 'rgba(255, 255, 255, 0)',
  sponsorImage: '',
  sponsorImageFormat: 'logo',
  sponsorImageBackgroundColor: 'rgba(255, 255, 255, 0)',
  sponsorImagePages: [],
  namespace: '',
  owner: '',
  postQuizQuestion: '',
  postQuizQuestionAnswer1: '',
  postQuizQuestionAnswer2: '',
  postQuizQuestionAnswer3: '',
  postQuizQuestionAnswer4: '',
  postQuizQuestionEnabled: false,
  theme: {
    primaryColor: '#fff',
    primaryFont: 'Montserrat',
    primaryFontColor: '#fff',
    primaryButtonGradientStart: "#facc22",
    primaryButtonGradientEnd: "#f83600",
    primaryButtonFontColor: "#282728",
    selectedAnswerButtonGradientStart: "#97bf50",
    selectedAnswerButtonGradientEnd: "#c2ca42",
    selectedAnswerButtonFontColor: "#fff",
    progressBarColor: "#e500ff",
    contentBackgroundColor: "rgba(0,0,0,0.6)",
  },
  questionsSettings: {
    font: 'Montserrat',
    randomizeOrder: false,
    limit: '',
    highlightCorrectAnswer: false,
    delay: 2,
    correctAnswerColor: "#22c55e",
    incorrectAnswerColor: "#f04444",
  },
  prizes: [],
  prizesButtonGradientStart: "#97bf50",
  prizesButtonGradientEnd: "#c2ca42",
  prizesButtonFontColor: "#000",
  backets: [],
  callToAction: {
    enabled: true,
    resultButtonTitle: 'See how you placed',
    url: '',
    text: '',
    image: '',
    title: '',
    clickBonusPoints: '500',
  },
  promoVideo: '',
  publicDevicePlayableOnly: false,
  quizGroup: '',
  quizName: '',
  waiver: {
    enabled: false,
    showBrandLogo: false,
    text: '',
  },
  resultsPage: {
    enabled: true,
    disabledPageText: "Thanks for playing!\nThe leaderboard is turned off for this game. We’ll share the final results on our social media and contact you by email if you’re a winner!",
    placingGradientStart: '#be7eea',
    placingGradientEnd: '#687fd9',
    placingFontColor: '#242324',
    currentPlacingGradientStart: '#e3722d',
    currentPlacingGradientEnd: '#f4d549',
    currentPlacingFontColor: '#242324',
    socialShare: {
      enabled: true,
      url: '',
      image: '',
      hashtags: '',
      bonusValue: 500,
    }
  },
  spotPrizesEnabled: false,
  spotPrizes: '',
  startsDate: '',
  videoEndQuiz: '',
  videoMidQuiz: '',
  videoStartQuiz: '',
  videoUrl: '',
  wallpaperImage: 'https://media.quizwizards.com/wallpaper-default.jpg',
  language: 'en',
  additionalLanguages: [],
  translations: {},
  publicLeaderboard: {
    enabled: true,
    teamEnabled: true,
    headerText: '',
    wallpaperImage: 'https://media.quizwizards.com/bg-live-landscape.jpg',
    portraitWallpaperImage: 'https://media.quizwizards.com/bg-live-portrait.jpg',
    quizQRCodeEnabled: true,
    quizQRCodeTitle: 'Scan To Play',
    quizQRCodeLink: '',
    quizQRCodeLogo: '',
    quizQrCodeLogoFormat: 'logo',
    textColor: '#FFFFFF',
    primaryColor: '#f99014',
    secondaryColor: '#f4d549',
    backgroundColor: 'rgba(0,0,0,0.6)',
    questionsTimeout: 5
  },
  countdownPage: {
    enabled: true,
    title: 'Get Ready to Play!',
    text1: 'Answer fast, score big!',
    text2: '',
  },
  scoringResultPage: {
    enabled: false,
    image: '',
    primaryColor: '#ff9100',
    bands: [
      { ref: uuidv4(), minPercentage: 76, title: 'Outstanding' },
      { ref: uuidv4(), minPercentage: 51, title: 'Well Done' },
      { ref: uuidv4(), minPercentage: 26, title: 'Nice Effort' },
      { ref: uuidv4(), minPercentage: 0, title: 'Good Try' },
    ],
  },
  consents: []
};